
// Action Types
export const LOGIN = "LOGIN"; 
export const LOGOUT = "LOGOUT"; 


// Action Creator
export const login = (data) => ({
   type: LOGIN,
   payload:{
        userName:data.userName,
        personNumber:data.personNumber,
        businessArea:data.businessArea,
        personArea: data.pers_area,
        personSubArea: data.pers_subarea,
        companyCode:data.companyCode,
        bookingStatus:data.bookingStatus,
        costCenter:data.costCenter,
        userRole:data.userRole,
        sessionId:data.sessionId,
        profileImg: data.profileImg
   } 
});
export const logOut = () => ({
    type: LOGOUT ,

 });


